import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accountDetail: {
      paddingBottom: theme.spacing(3),
    },
    title: {
      paddingBottom: theme.spacing(1),
    },
  })
);
